import * as React from  'react';
import { Button } from '@mui/material';
import { Link as LinkRouter} from 'react-router-dom';

interface ButtonLinkProps {
    to: string,
    startIcon?: React.ReactElement, 
    children: React.ReactNode | React.ReactNode[] | string,
    fullWidth?: boolean,
    state?: {[key: string]: any}
    disabled?: boolean,
    variant?: 'contained' | 'text';
}

export const ButtonLink = ({to, startIcon, children, fullWidth, state, disabled, variant='contained'}: ButtonLinkProps) => {
    return <Button disabled={disabled} fullWidth={fullWidth} className={"buttonLink"} startIcon={startIcon} component={LinkRouter} to={to} state={state} variant={variant}>{children}</Button>
}